import "@fontsource/staatliches/400.css";
import "@piducancore/fonts-andale-mono";

const theme = {
  breakpoints: ["40em", "52em", "64em"],
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: "Andale Mono",
    heading: "Staatliches",
    monospace: "Silom, monospace",
  },
  fontSizes: [12, 14, 16, 18, 22, 32, 48, 64, 96],
  fontWeights: {
    body: 400,
    heading: 700,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },
  colors: {
    text: "#000",
    background: "#fff",
    primary: "#ff0023",
    secondary: "#30c",
    muted: "#646464",
  },
  sizes: {
    container: 480,
  },
  cards: {
    primary: {
      padding: 3,
      border: (t) => `4px dashed ${t.colors.text}`,
      boxShadow: "0 0 8px rgba(0, 0, 0, 0.125)",
      bg: "background",
    },
  },
  forms: {
    label: {
      fontFamily: "body",
      fontSize: 2,
      fontWeight: "bold",
    },
    input: {
      fontFamily: "body",
      borderColor: "gray",
      mb: 2,
      "&:focus": {
        borderColor: "primary",
        boxShadow: (t) => `0 0 0 2px ${t.colors.primary}`,
        outline: "none",
      },
    },
  },
  text: {
    heading: {
      fontFamily: "heading",
      lineHeight: "heading",
      fontWeight: "heading",
    },
  },
  buttons: {
    primary: {
      transition: "all .2",
      border: (theme) => `1px solid ${theme.colors.primary}`,
      cursor: "pointer",
      bg: "primary",
      color: "background",

      "&:hover": {
        bg: "background",
        color: "primary",
      },
    },
    disabled: {
      border: (theme) => `1px solid ${theme.colors.muted}`,
      color: "muted",
      bg: "background",
      cursor: "progress",
    },
  },
  styles: {
    root: {
      fontFamily: "body",
      lineHeight: "body",
      fontWeight: "body",
      fontSize: 3,
    },
    h1: {
      variant: "text.heading",
      fontSize: 5,
    },
    h2: {
      variant: "text.heading",
      fontSize: 4,
    },
    h3: {
      variant: "text.heading",
      fontSize: 3,
    },
    h4: {
      variant: "text.heading",
      fontSize: 2,
    },
    h5: {
      variant: "text.heading",
      fontSize: 1,
    },
    h6: {
      variant: "text.heading",
      fontSize: 0,
    },
    pre: {
      fontFamily: "monospace",
      overflowX: "auto",
      code: {
        color: "inherit",
      },
    },
    code: {
      fontFamily: "monospace",
      fontSize: "inherit",
    },
    table: {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: 0,
    },
    th: {
      textAlign: "left",
      borderBottomStyle: "solid",
    },
    td: {
      textAlign: "left",
      borderBottomStyle: "solid",
    },
    a: {
      color: "primary",
      fontWeight: "heading",
      textDecoration: "none",
      "&:hover": {
        color: "secondary",
      },
      cursor: "pointer",
    },
  },
};

export default theme;
